export default __webpack_public_path__ + "static/media/back.49f67212.svg";